import { Box, Typography, Button, Chip } from '@mui/material';
import { Warning, PersonOff } from '@mui/icons-material';
import { useImpersonate } from '../auth/ImpersonateContext';

export const ImpersonateBanner: React.FC = () => {
  const { isImpersonating, impersonatedUser, stopImpersonation } = useImpersonate();

  if (!isImpersonating || !impersonatedUser) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        px: 3,
        py: 1,
        bgcolor: 'warning.main',
        color: 'warning.contrastText',
        flexWrap: 'wrap',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Warning fontSize="small" />
        <Typography variant="body2" fontWeight={600}>
          Impersonating:
        </Typography>
        <Typography variant="body2">
          {impersonatedUser.displayName} ({impersonatedUser.email})
        </Typography>
        <Chip
          label={impersonatedUser.systemRole}
          size="small"
          sx={{ bgcolor: 'warning.dark', color: 'warning.contrastText', fontWeight: 600 }}
        />
      </Box>
      <Button
        size="small"
        variant="outlined"
        startIcon={<PersonOff />}
        onClick={stopImpersonation}
        sx={{
          borderColor: 'warning.contrastText',
          color: 'warning.contrastText',
          '&:hover': { bgcolor: 'warning.dark', borderColor: 'warning.contrastText' },
        }}
      >
        Stop Impersonation
      </Button>
    </Box>
  );
};
